import { call, put, takeLatest } from 'redux-saga/effects';

import { footerUpdateError, footerUpdateRequest, footerUpdateStore } from './footerActions.js';
import { updateFooterApiCall } from './footerAPI.js';

function* updateFooterSaga({ payload }) {
  try {
    yield call(updateFooterApiCall, payload);
    yield put(footerUpdateStore());
  } catch (error) {
    yield put(footerUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* emailsFooterWatcher() {
  yield takeLatest(footerUpdateRequest.type, updateFooterSaga);
}
